import { DateTime } from '@ksyos/date-time';
import { Card, Col, FormGroup, FormParagraph, Row, Text } from '@ksyos/design-system';
import { BankAccountEntity } from '@common/enums/bankAccountEntity';
import { CompensationPayoutLevel } from '@common/enums/compensationPayoutLevel';
import { translateKey } from '../../../translate';
import { BankAccountDetails } from '../bankAccountDetails/BankAccountDetails';

interface IUpcomingPaymentsOverviewProps {
    payoutLevel: CompensationPayoutLevel.employment | CompensationPayoutLevel.organization;
    payoutLevelEntityId: string;
}

const getPeriodLabel = () => {
    const now = DateTime.now();
    if (now.isBefore(`${now.year()}-02-15`)) {
        return DateTime.from(`${now.year() - 1}-12-31`);
    } else if (now.isBefore(`${now.year()}-05-15`)) {
        return DateTime.from(`${now.year()}-03-31`);
    } else if (now.isBefore(`${now.year()}-08-15`)) {
        return DateTime.from(`${now.year()}-06-30`);
    } else if (now.isBefore(`${now.year()}-11-15`)) {
        return DateTime.from(`${now.year()}-09-30`);
    } else {
        return DateTime.from(`${now.year()}-12-31`);
    }
};

export function UpcomingPaymentsOverview(props: IUpcomingPaymentsOverviewProps) {
    const periodLabel = getPeriodLabel();
    const dateOfPaymentLabel = periodLabel.add(2, 'months').date(15);
    const specsAvailableOnLabel = dateOfPaymentLabel.date(1);

    return (
        <>
            <Card>
                <Card.Body>
                    <FormGroup label={translateKey('common.period')}>
                        <Row columnGap={2}>
                            <Col>
                                <FormParagraph>{translateKey('common.until')}</FormParagraph>
                            </Col>
                            <Col>
                                <FormParagraph>{periodLabel.format('DD-MM-YYYY')}</FormParagraph>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup label={translateKey('finance.dateOfPayment')}>
                        <FormParagraph>
                            {translateKey('common.around', dateOfPaymentLabel.format('DD-MM-YYYY'))}
                        </FormParagraph>
                    </FormGroup>

                    <BankAccountDetails
                        bankAccountEntity={
                            props.payoutLevel === CompensationPayoutLevel.employment
                                ? BankAccountEntity.employment
                                : BankAccountEntity.organization
                        }
                        canRequestChange={true}
                        entityId={props.payoutLevelEntityId}
                        extraBottomElements={
                            <Text
                                color="minimal"
                                mt={6}
                                size="sm"
                            >
                                {translateKey('finance.specsAvailableOn', specsAvailableOnLabel.format('D MMMM YYYY'))}
                            </Text>
                        }
                    />
                </Card.Body>
            </Card>
        </>
    );
}
